import React from "react";
import {Button, Card, DatePicker, Drawer, Form, Input, InputNumber, Modal, Popover, Select, Table, Tooltip} from "antd";
import {CrmHeaderLinks} from "../CrmHeaderLinks";
import {GeneratorClientData} from "./generator-client/GeneratorClientData";
import {BillToClientData} from "./bill_to_client/BillToClientData";
import {ShowWorkOrder} from "../../tracks/workorder/popups/ShowWorkOrder";
import {pagination} from "../../../controller/Utils";
import {WorkOrderList} from "../../../models/workorder";
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Legend} from 'recharts';

const dataChart = [
  {
    name: '1', income: 4000, expense: 2400,
  }, {
    name: '2', income: 3000, expense: 1398,
  }, {
    name: '3', income: 2000, expense: 9800,
  },{
    name: '4', income: 2780, expense: 3908,
  },{
    name: '5', income: 9800, expense: 4800,
  },{
    name: '6', income: 2390, expense: 3800,
  },{
    name: '7', income: 3490, expense: 4300,
  },{
    name: '8', income: 2000, expense: 9800,
  },{
    name: '9', income: 2780, expense: 3908,
  },
];
const moment = require('moment');
const Option = Select.Option;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;

export class ClientProfile extends React.Component {
   state = {
    visible: false,
    visibleWorkDrawer: false,
    visibleDetails: false,
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
    printVisible: false,
    printChoices: {},
    printBtnLoading: false,
    selected_value: '',
    visibleGenerator: false,
    visibleBillTo:false
  };

  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  };

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    params['table'] = true;
    WorkOrderList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };

  onRowShowClick = (ids) => {
    this.setShowWorkOrderModel(true);
    this.setState({ showWorkOrderModelData: ids })
  };
  onRowUpdateClick = (moderatedWorkOrder) => {
    this.setState({ moderatedWorkOrder });
    this.setAddUpdateWorkOrderModel(true);
  };
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye" /></a>
      </div>
    }, {
      title: 'Created Date',
      dataIndex: 'created',
      sorter: true,
      render: created => moment(created).format('YYYY-MM-DD')
    }, {
      title: 'Work Order Number',
      dataIndex: 'work_order_number',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top" title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span className="uppercase-letter">{generator.company_name}<br />ID: {generator.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <Tooltip placement="top" title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br /> ID: {bill_to.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Truck Type</span>,
      dataIndex: 'service',
      key :'truck_type',
      render: service => service.map(service => service.truck_type.map(type => type.type_name).join(', ')).join(' | '),
    },
    {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'transporter',
      render: service =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.transporter.name}</p>)}
          </div>}
          title="All Transporter">
          <a type="primary">{service[0].transporter.name} <i className="fa fa-info-circle" /></a>
        </Popover>,
      sorter: true
    },
    {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service date',
      sorter: true,
      render: (service) =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.service_date}<Tooltip title={item.status}><span className={"status-services " + (item.status)}><i className="fa fa-circle" /></span></Tooltip></p>)}
          </div>} title="All Service Date">
          <a type="primary">{service[0].service_date} <i className="fa fa-info-circle" /></a>
        </Popover>
    }
  ];

  setAddUpdateWorkOrderModel(addUpdateWorkOrderModel) {
    this.setState({ addUpdateWorkOrderModel });
  }

  setShowWorkOrderModel(showWorkOrderModel) {
    this.setState({ showWorkOrderModel });
  }

  setChoiceWorkOrder(setChoiceWorkOrderModel) {
    this.setState({ setChoiceWorkOrderModel })
  }


  onCloseWork = () => {
    this.setState({
      visibleWorkDrawer: false,
    });
  };
  showDetailsDrawer = () => {
    this.setState({
      visibleDetails: true,
    });
  };

  onCloseDetails = () => {
    this.setState({
      visibleDetails: false,
    });
  };

  handleSelect = (value) => {
    this.setState({selected_value: value});
    if(value==="generator"){
      this.visibleGeneratorModal(true)
    }
    else if(value==="bill_to"){
      this.visibleBillToModal(true)
    }
  };
  visibleGeneratorModal = (visible) =>{
      this.setState({visibleGenerator: visible})
  };
  visibleBillToModal = (visible) =>{
      this.setState({visibleBillTo: visible})
  };
  handleSelectedValue = (value) => {
    const {selected_value, params} = this.state;
    delete params['generator__id'];
    delete params['bill_to__id'];
    this.setState({selectedValueData: value, params});
    if (selected_value === "generator")
      this.fetch({'generator__id': value.id});
    else if (selected_value === "bill_to")
      this.fetch({'bill_to__id': value.id})
  };

  render() {
    const {pagination, data, loading, selectedRowKeys, selected_value, selectedValueData} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB CRM</h3>
              </div>
              <div className="col-sm-9 col-12">
                <CrmHeaderLinks/>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3 col-xs-12 performed-select">
                <div className="select-explore-div">
                  <Select showSearch style={{width: "100%"}} placeholder="Select Data Category"
                          optionFilterProp="children" onSelect={this.handleSelect}>
                    <Option value="generator">Generator</Option>
                    <Option value="bill_to">Bill To</Option>
                  </Select>
                </div>
              </div>
            </div>
            {selected_value.length>0 && selectedValueData !== undefined ? <React.Fragment>
              <div className="row clearfix ml-0 mr-0 m-t-15">
                <div className="col-12">
                  <h3 className="main-heading">{selected_value === "generator"? "Generator Information":"Bill To Information"}</h3>
                </div>
                <div className="col-sm-9 col-xs-120">
                  <div className="row clearfix main-card">
                    <div className="col-sm-3 col-12">
                      <Card title="Name" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.account_number} | {selectedValueData.company_name}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Email" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.email}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Address" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.address}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="City" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.city}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="State" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.state}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="ZIP Code" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <h4>{selectedValueData.zip_code}</h4>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Phone" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>{selectedValueData.phone}</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Contact" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>{selectedValueData.contact}</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Payment Term" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>NET30</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Payment Status" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>Satisfactory</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Notes" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <div className="col-12 padding-0 multiple-enrty">
                          <h4>{selectedValueData.notes}</h4>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Client Since" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <div className="col-12 padding-0 multiple-enrty">
                          <h4>{selectedValueData.created}</h4>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Income" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                        <div className="col-12 padding-0 multiple-enrty">
                          <p><a>$30,325.15</a></p>
                        </div>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Associate Generator" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>CON Edition</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                    <div className="col-sm-3 col-12">
                      <Card title="Last Service Date" extra={<a  href="#"><i className="fa fa-info"> </i> </a>} style={{ width: "100%" }} bordered={false}>
                          <h4>2019-02-07</h4>
                          <a href="#"><i className="fa fa-pencil" /></a>
                      </Card>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3 col-xs-12 paddingZ-xs">
                  <div className="job-details-bar">
                    <h4>Client's Tracking Tools</h4>
                    <ul>
                      <li><a onClick={this.showDetailsDrawer} href="#">Billing <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={this.showDetailsDrawer} href="#">Client Files <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={this.showDetailsDrawer} href="#">Client Project Logs <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={this.showDetailsDrawer} href="#">Attachment <i className="fa fa-pencil"> </i> </a></li>
                      <li><a onClick={this.showDetailsDrawer} href="#">Dispatch History<i className="fa fa-pencil"> </i> </a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row ml-0 mr-0 clearfix">
                <div className="col-12 chart-div">
                  <div className="row">
                    <div className="col-sm-4 col-12">
                      <RangePicker/>
                    </div>
                  </div>
                  <LineChart width={1000} height={300} data={dataChart}>
                   <XAxis dataKey="name"/>
                   <YAxis/>
                   <CartesianGrid strokeDasharray="3 3"/>
                   <Tooltip/>
                   <Legend />
                   <Line type="monotone" dataKey="expense" stroke="#8884d8" activeDot={{r: 8}}/>
                   <Line type="monotone" dataKey="income" stroke="#09902a" />
                  </LineChart>
                </div>
              </div>
              <div className="row clearfix">
                <div className="col-12">
                  <div className="listing-table">
                    <Table
                      className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                      pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                      dataSource={data} loading={loading} onChange={this.handleTableChange}
                      locale={{ emptyText: 'No Work Order Available' }} />
                  </div>
                </div>
              </div>
            </React.Fragment>: ''}
              <Modal title="Loss Coordinator Assignment" visible={this.state.visible} footer={null} onCancel={this.handleCancel} centered>
                <label>Coordinator</label>
                 <Select className="m-b-20 m-t-10" defaultValue="Select An Option" style={{ width: "100%" }}>
                    <Option value="select">Select An Option</Option>
                    <Option value="collection">Collection Agents</Option>
                    <Option value="air">All Green Air</Option>
                    <Option value="alisa">Alisa Pierson</Option>
                    <Option value="shannon">Shannon Franz</Option>
                 </Select>
                  <Button className="m-r-10" type="primary">Save Changes</Button>
                  <Button type="default" onClick={this.handleCancel}>Cancel</Button>
              </Modal>
              <Drawer title="Add Work Order" placement="right" onClose={this.onCloseWork} visible={this.state.visibleWorkDrawer}
              className="floating-form" destroyOnClose={true} width={"35%"}>
              <Form>
                <FormItem label="Email">
                  <Input placeholder="Enter  email" />
                </FormItem>
                <FormItem label="City">
                  <Input placeholder="Enter city" />
                </FormItem>
                <FormItem label="State">
                  <Input placeholder="Enter state" />
                </FormItem>
                <FormItem label="Zip Code">
                  <Input placeholder="Enter zip code" />
                </FormItem>
                <FormItem label="Phone">
                  <Input placeholder="Enter phone" />
                </FormItem>
                <FormItem label="Contact">
                  <Input placeholder="Enter contact" />
                </FormItem>
                <Button type="primary" htmlType="button" >
                  Add Work Order
                </Button>
              </Form>
            </Drawer>
              <Drawer title="Client Tracking Tools" placement="right" onClose={this.onCloseDetails} visible={this.state.visibleDetails}
              className="floating-form" destroyOnClose={true} width={"35%"}>
              <Form>
                <FormItem label="Email">
                  <Input placeholder="Enter  email" />
                </FormItem>
                <FormItem label="City">
                  <Input placeholder="Enter city" />
                </FormItem>
                <FormItem label="State">
                  <Input placeholder="Enter state" />
                </FormItem>
                <FormItem label="Zip Code">
                  <Input placeholder="Enter zip code" />
                </FormItem>
                <FormItem label="Phone">
                  <Input placeholder="Enter phone" />
                </FormItem>
                <FormItem label="Contact">
                  <Input placeholder="Enter contact" />
                </FormItem>
                <Button type="primary" htmlType="button" >
                  Update
                </Button>
              </Form>
            </Drawer>
              <ShowWorkOrder visible={this.state.showWorkOrderModel} setModelVisible={() => this.setShowWorkOrderModel(false)} data={this.state.showWorkOrderModelData} />

            <GeneratorClientData selectedGenerator={this.handleSelectedValue} visible={this.state.visibleGenerator} onClose={()=>this.visibleGeneratorModal(false)} />
            <BillToClientData selectedBillToData={this.handleSelectedValue} visible={this.state.visibleBillTo} onClose={()=>this.visibleBillToModal(false)} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/crm/client_profile/ClientProfile.jsx